import React, { useContext, useEffect, useRef } from 'react';
import { VideoControl } from '../../containers/post/post-sm';

const VideoPostItemSm = ({ src }) => {
  const provider = useContext(VideoControl);
  const video = useRef();
  const source = useRef();
  const control = useRef();

  useEffect(() => {
    video.current.pause();

    const handleControl = () => {
      if (video.current.paused) {
        if (provider.video.current && !provider.video.current.paused) {
          provider.video.current.pause();
          provider.control.current.classList.remove('hide-control');
        }
        provider.setVideo(video.current);
        provider.setControl(control.current);

        video.current.play();
        control.current.classList.add('hide-control');
      } else {
        video.current.pause();
        control.current.classList.remove('hide-control');
      }
    };

    control.current.addEventListener('click', handleControl);
  }, []);

  return (
    <>
      <video className="media-video" autoPlay={false} loop={true} ref={video}>
        <source src={src} type="video/mp4" ref={source} />
      </video>
      <div className={`all-center media-control-caption`} ref={control}>
        {<span className={'videoSpritePlayButton'} />}
      </div>
    </>
  );
};

export default VideoPostItemSm;
